import { createRoute } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { InboxRulesPage } from '@/components/inbox/rules-page'
import { InboxFeatureGate } from '@/components/inbox/feature-gate'

export const inboxRulesRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/inbox/rules',
  component: InboxRulesRoutePage,
})

function InboxRulesRoutePage() {
  const { projectId } = inboxRulesRoute.useParams()
  return (
    <InboxFeatureGate projectId={projectId}>
      <InboxRulesPage projectId={projectId} />
    </InboxFeatureGate>
  )
}
